import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from '@mui/icons-material/Add';
import PostDialog from '../../../SpiderWebSite/components/PostDialog';
import { IReduxState } from '../../../store';
import AttribuerDroit from './AttribuerDroit';
import { IModule } from '../../../components/GestionFonctionnalite/Module/moduleSlice';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../util/apiClient';

interface IAddProps {
  state: IAddUser
  setState: (x: IAddUser) => void
  rightsChecked: IModule[]
  setRightsChecked: (x: IModule[]) => void
}


const AddUser = (props: IAddProps) => {

  //props
  const { state, setState, rightsChecked, setRightsChecked } = props

  //redux
  const { typeUtilisateurs } = useSelector((state: IReduxState) => state.users);


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setState({ ...state, [name]: value })
  }




  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={4} xs={12} sm={4}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idTypeUtilisateur"
                label="Type utilisateur"
                value={state.idTypeUtilisateur}
                onChange={handleInputChange}
              >
                {typeUtilisateurs.map((option) => (
                  <MenuItem key={option.idTypeUtilisateur} value={option.idTypeUtilisateur}>
                    {option.libTypeUtilisateur}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                size="small"
                name="nomUtilisateur"
                label="Nom utilisateur"
                value={state.nomUtilisateur}
                onChange={handleInputChange}
              />
            </Grid>
            {
              state.idTypeUtilisateur && state.idTypeUtilisateur !== 1 &&
              <Grid item xs={12} sm={12} md={12}>
                <AttribuerDroit
                  rightsChecked={rightsChecked}
                  setRightsChecked={setRightsChecked}
                />
              </Grid>
            }
          </Grid>
        </Grid>

      </Grid>
    </Box>
  );
};





export interface IAddUser {
  idTypeUtilisateur: number | null;
  nomUtilisateur: string;
}

export const initialState: IAddUser = {
  idTypeUtilisateur: null,
  nomUtilisateur: "",
}


const DialogAdd = () => {

  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [state, setState] = useState<IAddUser>(initialState)
  const [rightsChecked, setRightsChecked] = React.useState<IModule[]>([]);

  //Ouvrir la boite de dialog 
  const onClose = () => {
    setOpen(false)
  }

  //Fermer la boite de dialog
  const handleOpenDialog = () => {
    setOpen(true)
  }

  const handleSave = async (e: any) => {
    e.preventDefault()
    try {
      const apiPayload = {
        user: state,
        rights: rightsChecked
      }
      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/adduserwithhisright", apiPayload)
      if (res.status === 1) {
        // dispatch(addModules(res.data))
      } else {
        console.log("status !==1")
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:155 ~ handleSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={<AddUser
        state={state}
        setState={setState}
        rightsChecked={rightsChecked}
        setRightsChecked={setRightsChecked}
      />}
      actionFunc={handleSave}
      title="Ajout d'utilisateur"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



